import { useEffect, useState } from "react";
import LayoutWeb from "../LayoutWeb/layoutWeb";
import { getAllWebData } from "../../api/webData.api";
import "./Web.scss";
import VideoSectionEditForm from "../../components/EditWebData/HomePage/VideoSectionEditForm";
import CategoriesEditForm from "../../components/EditWebData/HomePage/CategoriesEditForm";

const Web = () => {
  const [webData, setWebData] = useState([]);
  const [openEditCategoriesForm, setOpenEditCategoriesForm] = useState(false);
  const [openEditVideoSectionForm, setOpenEditVideoSectionForm] =
    useState(false);
  const [hideContent, setHideContent] = useState(false);

  async function fetchGetAllWebData() {
    const webData = await getAllWebData();
    setWebData(webData[0]);
  }

  useEffect(() => {
    fetchGetAllWebData();
  }, []);

  // --- HELPER VISUAL UNIFICADO ---
  const renderPreview = (data, type) => {
    // 1. LÓGICA PARA OBTENER LA URL SEGURA DE LA IMAGEN
    const getImageSrc = (imgUrl) => {
      if (!imgUrl) return "/Logo_animated.svg"; // Si es null o undefined

      // Si es una ruta local (ej: "/images/...") o base64, la dejamos igual
      if (imgUrl.startsWith("/") || imgUrl.startsWith("data:")) return imgUrl;

      // Si ya empieza por http (incluye https y http), la dejamos igual
      if (imgUrl.startsWith("http")) return imgUrl;

      // Si no tiene protocolo (ej: "gvre-images.fra1..."), le ponemos https://
      return `https://${imgUrl}`;
    };

    // 2. LÓGICA PARA EL VIDEO
    const getVideoSrc = (vidUrl) => {
      if (!vidUrl) return "";
      return vidUrl.startsWith("http") ? vidUrl : `https://${vidUrl}`;
    };

    return (
      <div className="previewContainer">
        {type === "image" ? (
          <img
            // USAMOS LA FUNCIÓN SEGURA AQUÍ
            src={getImageSrc(data?.image)}
            alt={data?.title || "Imagen"}
            className="image-and-video-styles"
          />
        ) : (
          <video
            src={getVideoSrc(data?.video)}
            controls
            preload="metadata"
            playsInline
            className="image-and-video-styles"
            muted
          />
        )}
        <div className="previewContainer__title">
          <span>{data?.title || "Sin Título"}</span>
          <span>{data?.subtitle || "Sin Subtítulo"}</span>
        </div>
      </div>
    );
  };

  return (
    <LayoutWeb subTitle="Home page">
      <div className="HomePageTitle">{!hideContent && <h1>Home page</h1>}</div>

      {/* --- MODALES --- */}
      {/* {openEditHomeTitleForm && (
        <TitleAndImageEditForm
          setOpenEditHomeTitleForm={setOpenEditHomeTitleForm}
          webData={webData}
          setWebData={setWebData}
          setHideContent={setHideContent}
        />
      )} */}

      {openEditCategoriesForm && (
        <CategoriesEditForm
          setOpenEditCategoriesForm={setOpenEditCategoriesForm}
          webData={webData}
          setWebData={setWebData}
          setHideContent={setHideContent}
        />
      )}

      {openEditVideoSectionForm && (
        <VideoSectionEditForm
          setOpenEditVideoSectionForm={setOpenEditVideoSectionForm}
          webData={webData}
          setWebData={setWebData}
          setHideContent={setHideContent}
        />
      )}

      {/* --- CONTENIDO --- */}
      {!hideContent && webData?.length !== 0 ? (
        <>
          {/* 1. SECCIÓN VIDEOS */}
          <h2 className="LayoutWeb__contain__children__title">
            Sección de Videos
          </h2>
          <div className="ContainerColumn">
            <div className="ContainerColumn__text">
              <strong>Título: </strong>{" "}
              <span>
                {webData?.videoSection?.title || "Sin título definido"}
              </span>
            </div>

            <div className="ContainerColumn__text">
              <strong>Subtítulo: </strong>{" "}
              <span style={{ textAlign: "center" }}>
                {webData?.videoSection?.subtitle || "Sin subtítulo definido"}
              </span>
            </div>

            <div className="ContainerColumn__content">
              {webData?.videoSection?.videos?.length > 0 ? (
                webData.videoSection.videos.map((vidData, index) => {
                  // COMPROBACIÓN DE SEGURIDAD
                  // El backend ahora devuelve objetos, pero si hay datos viejos (strings) no queremos que rompa.
                  const isNewFormat = typeof vidData === "object";
                  const videoUrl = isNewFormat ? vidData.videoUrl : vidData;

                  // Preparamos los datos para mostrar
                  const displayTitle = isNewFormat
                    ? vidData.title
                    : `Video ${index + 1}`;
                  // Puedes concatenar referencia o precio al subtítulo
                  const displaySubtitle = isNewFormat
                    ? `${vidData.adReference} | ${vidData.price?.label}`
                    : "Sin datos extra";

                  return (
                    <div key={index}>
                      {/* Reutilizamos tu renderPreview. 
                         Pasamos los datos enriquecidos del anuncio.
                      */}
                      {renderPreview(
                        {
                          video: videoUrl,
                          title: displayTitle,
                          subtitle: displaySubtitle,
                        },
                        "video",
                      )}
                    </div>
                  );
                })
              ) : (
                <p>No hay videos vinculados actualmente.</p>
              )}
            </div>

            <button
              type="button"
              className="subHeader__btn"
              onClick={() => {
                setOpenEditVideoSectionForm(true);
                setHideContent(true);
              }}
            >
              Editar
            </button>
          </div>

          {/* 2. SECCIÓN PORTADA (Hero Image) */}
          {/* <h2 className="LayoutWeb__contain__children__title">
            Sección de Portada Home
          </h2>
          <div className="ContainerColumn">
            <div className="ContainerColumn__content">
              {renderPreview(
                {
                  image: webData?.portraidImage,
                  title: `GV ${webData?.mainTitle || ""}`,
                },
                "image",
              )}
            </div>

            <button
              type="button"
              className="subHeader__btn "
              onClick={() => {
                setOpenEditHomeTitleForm(true);
                setHideContent(true);
              }}
            >
              Editar
            </button>
          </div> */}

          {/* 3. SECCIÓN CATEGORÍAS Y UBICACIONES */}
          <h2 className="LayoutWeb__contain__children__title">
            Sección Categorías y Ubicaciones
          </h2>
          <div className="ContainerColumn">
            {/* SUB-SECCIÓN: CATEGORÍAS PRINCIPALES */}
            <div className="ContainerColumn__text">
              <strong>Categorías Principales</strong>
            </div>

            <div className="ContainerColumn__content">
              {renderPreview(webData?.categoriesSection?.residential, "image")}
              {renderPreview(webData?.categoriesSection?.patrimonial, "image")}
              {renderPreview(webData?.categoriesSection?.others, "image")}
            </div>

            {/* SUB-SECCIÓN: UBICACIONES */}
            <div className="ContainerColumn__text">
              <strong>Ubicaciones Destacadas</strong>
            </div>

            <div className="ContainerColumn__content">
              {renderPreview(webData?.categoriesSection?.location1, "image")}
              {renderPreview(webData?.categoriesSection?.location2, "image")}
              {renderPreview(webData?.categoriesSection?.location3, "image")}
              {renderPreview(webData?.categoriesSection?.location4, "image")}
            </div>

            <button
              type="button"
              className="subHeader__btn"
              onClick={() => {
                setOpenEditCategoriesForm(true);
                setHideContent(true);
              }}
              style={{ marginTop: "20px" }}
            >
              Editar
            </button>
          </div>
        </>
      ) : null}
    </LayoutWeb>
  );
};

export default Web;
